import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sivFollowupLetterAPI = createApi({
  baseQuery,
  reducerPath: 'SIVFollowupLetterAPI',
  endpoints: builder => ({
    getSivFollowupLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sivFollowupLetter.getAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    selectSivFollowupLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country, visit_follow_up_id }) => ({
        url: `${formatString(
          endPoints.sivFollowupLetter.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }${
          visit_follow_up_id !== null || visit_follow_up_id !== undefined
            ? `&visit_follow_up_id=${visit_follow_up_id}`
            : ''
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateSivFollowupLetter: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(
          endPoints.sivFollowupLetter.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSivFollowupLetter: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        monitoring_visit_id,
        publish_doc_version,
        time_zone_id,
        is_published,
        update
      }) => ({
        url: `${formatString(
          endPoints.sivFollowupLetter.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&monitoring_visit_id=${monitoring_visit_id}&publish_doc_version=${publish_doc_version}&time_zone_id=${time_zone_id}&is_published=${is_published}&update=${update}`,
        method: 'POST'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createNewVersion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, application_section, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sivFollowupLetter.createNewVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.sq_visit_id, value: sq_visit_id }
        )}?country=${country}&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'POST'
      })
    })
  })
});

export const {
  useLazyGetSivFollowupLetterQuery,
  useLazySelectSivFollowupLetterQuery,
  useUpdateSivFollowupLetterMutation,
  usePublishSivFollowupLetterMutation,
  useCreateNewVersionMutation
} = sivFollowupLetterAPI;
